<template>
  <div class="profile">
    <!-- 侧边导航 -->
    <div class="side-nav">
      <div class="user-head">
        <!-- 头像 -->
        <img v-if="this.$store.state.user.userIconPath" width="84px" height="84px"
          :src="this.$store.state.user.userIconPath" alt="">
        <img v-if="!this.$store.state.user.userIconPath" width="84px" height="84px"
          src="@/assets/img/profile/headImg.png">
        <!-- 名字 -->
        <span>{{this.$store.state.user.userName}}</span>
      </div>

      <!-- 用户选择列表（侧边） -->
      <div class="user-list">
        <div class="user-list-my">
          <img src="@/assets/img/profile/user.png" alt="">
          <span>我的</span>
        </div>

        <el-radio-group v-model="radio">
          <el-radio-button label="我的收藏"></el-radio-button>
        </el-radio-group>

        <el-radio-group v-if="this.$store.state.user.roleName == '超级管理员'||this.$store.state.user.roleName == '教师'"
          v-model="radio">
          <el-radio-button label="我的上传"></el-radio-button>
        </el-radio-group>

        <div class="user-list-set">
          <img src="@/assets/img/profile/shezhi.png" alt="">
          <span>设置</span>
        </div>

        <el-radio-group :border='false' v-model="radio">
          <el-radio-button label="设置信息"></el-radio-button>
          <el-radio-button label="设置账户"></el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!--内容展示  -->
    <div class="profile-main">
      <!-- 顶部导航 -->
      <div class="top-nav">
        <ProfileTopNav :radio='radio' />
      </div>

      <!-- 展示内容 -->
      <div class="profile-content">
        <router-view />
      </div>

    </div>

  </div>
</template>

<script>
//顶部导航·····································
import ProfileTopNav from "./components/common/ProfileTobNav";
import { getUserMsg } from "@/network/loginRequest/api";
import utils from "@/util/index";
export default {
  name: "Profile",
  components: {
    ProfileTopNav,
  },
  data() {
    return {
      radio: "设置信息",
    };
  },

  created() {
    this.initRadio();
    //给vuex的用户信息添加用户基本信息--------------------------------------------
    this.setUserVueX();
  },

  watch: {
    //侧边导航--------------------------------------------
    radio(newValue) {
      this.goRoute(newValue);
    },
  },

  methods: {
    //给vuex的用户信息更新用户基本信息--------------------------------------------
    setUserVueX() {
      getUserMsg(this.$store.state.user.userId).then((res) => {
        if (res.data.success) {
          let obj = res.data.data;
          let user = this.$store.state.user;

          let newUser = {};
          for (const key in user) {
            if (user.hasOwnProperty(key)) {
              newUser[key] = user[key];
            }
          }

          //直接修改user会越过vuex--------------------------------------------
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              newUser[key] = obj[key];
            }
          }

          this.$store.commit("setUser", newUser);
        }
      });
    },

    //根据侧边导航栏显示相应的路由组件--------------------------------------------
    goRoute(name) {
      switch (name) {
        case "我的上传":
          this.$router.push({ name: "MyUpload" });
          break;
        case "我的收藏":
          this.$router.push({ name: "MyCollection" });
          break;
        case "设置信息":
          this.$router.push({ name: "SetInfo" });
          break;
        case "设置账户":
          this.$router.push({ name: "SetAccount" });
          break;
      }
    },

    //初始化radio(放在刷新时按钮激活状态改变)--------------------------------------------
    initRadio() {
      switch (this.$route.matched[1].name) {
        case "MyUpload":
          this.radio = "我的上传";
          break;
        case "MyCollection":
          this.radio = "我的收藏";
          break;
        case "SetInfo":
          this.radio = "设置信息";
          break;
        case "SetAccount":
          this.radio = "设置账户";
          break;
        default:
          this.radio = "我的收藏";
          break;
      }
    },
  },
};
</script>

<style lang='less' scoped>
.profile {
  width: 1200px;
  min-height: 800px;
  margin: 20px auto;
  display: flex;
}

.side-nav {
  width: 247px;
  margin-right: 10px;
  background-color: #fff;

  .user-head {
    min-height: 178px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #24ba58;

    img {
      border: 3px solid #bbf4cc;
      border-radius: 50%;
      margin-bottom: 15px;
    }

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }

  .user-list {
    min-height: 500px;
    margin: 27px 22px 0 19px;
    position: relative;

    .user-list-my {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      margin-left: 19px;
      img {
        margin-right: 10px;
      }
    }

    .user-list-set {
      display: flex;
      align-items: center;
      margin-top: 19px;
      margin-bottom: 20px;
      margin-left: 19px;

      img {
        margin-right: 10px;
      }
    }

    // 按钮UI样式修改
    .el-radio-group {
      display: flex;
      flex-direction: column;
      color: #333333;

      /deep/.el-radio-button {
        overflow: hidden;
        border-radius: 6px;
      }

      /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #24ba58;
        box-shadow: 0 0 0 0 #24ba58;
      }

      /deep/.el-radio-button__orig-radio:checked
        + .el-radio-button__inner:hover {
        color: #fff;
      }

      /deep/.el-radio-button__inner:hover {
        background-color: #e9f5ed;
        color: #333;
      }

      /deep/.el-radio-button__inner {
        width: 100%;
        height: 40px;
        font-size: 12px;
        font-weight: 400;
        font-family: Microsoft YaHei;
        border: 0;
        padding-left: 47px;
        text-align: left;
      }
    }
  }
}

.profile-main {
  width: 943px;
  min-height: 800px;

  .top-nav {
    height: 110px;
    margin-bottom: 5px;
    padding: 22px 0 13px 16px;
    background-color: #fff;
  }

  .profile-content {
    min-height: 690px;
    background-color: #fff;
    padding: 20px 16px 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}
</style>